import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToWords'
})
export class NumberToWordsPipe implements PipeTransform {

  transform(value: number): string {
    if (value === 0) {
      return 'zero';
    }
    
    const unidades = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
    const especiais = ['dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
    const dezenas = ['', 'dez', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];

    let word = '';

    if (value < 10) {
      word = unidades[value];
    } else if (value < 20) {
      word = especiais[value - 10];
    } else if (value < 100) {
      const dezena = Math.floor(value / 10);
      const unidade = value % 10;
      word = dezenas[dezena];
      if (unidade > 0) {
        word += ' e ' + unidades[unidade];
      }

      return word;

    } else if (value < 1000) {
      const centena = Math.floor(value / 100);
      const resto = value % 100;
      let centenaWord = '';

      if (value === 100) {
        return 'cem';
      }
      
      switch (centena) {
        case 1:
          centenaWord = 'cento';
          break;
        case 2:
          centenaWord = 'duzentos';
          break;
        case 3:
          centenaWord = 'trezentos';
          break;
        case 4:
          centenaWord = 'quatrocentos';
          break;
        case 5:
          centenaWord = 'quinhentos';
          break;
        case 6:
          centenaWord = 'seiscentos';
          break;
        case 7:
          centenaWord = 'setecentos';
          break;
        case 8:
          centenaWord = 'oitocentos';
          break;
        case 9:
          centenaWord = 'novecentos';
          break;
        default:
          centenaWord = '';
      }
      
      if (resto > 0) {
        return centenaWord + ' e ' + this.transform(resto);
      } else {
        return centenaWord;
      }
    } else if (value < 1000000) {
      const milhares = Math.floor(value / 1000);
      const resto = value % 1000;
      let milharesWord = '';

      if (milhares === 1) {
        milharesWord = 'mil';
      } else {
        milharesWord = this.transform(milhares) + ' mil';
      }
      
      if (resto > 0) {
        if (resto < 100) {
          return milharesWord + ' e ' + this.transform(resto);
        } else {
          return milharesWord + ' ' + this.transform(resto);
        }
      } else {
        return milharesWord;
      }
    }

    return word;
  } 
}
